import { type IUser } from '@on3/ui-lib/api/schema/custom-contracts';

export const userHasPermission = (
  roles: string[],
  user: IUser | null | undefined,
): boolean => {
  if (!user?.rg) {
    return false;
  }

  return user.rg.some((role) => roles.includes(role));
};
